function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React from 'react';
import { PremiumLocaleContext } from '../../providers/PremiumLocaleProvider/PremiumLocaleProvider';
import { formatCurrency } from './formatCurrency';
import { formatCurrencyToParts } from './formatCurrencyToParts';
export var PremiumCurrencyFormatter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PremiumCurrencyFormatter, _React$Component);
  function PremiumCurrencyFormatter() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized(_this), "getCurrencyFormatter", function (currencySettings) {
      return function (amount, formatConfig) {
        return formatCurrency(amount, currencySettings, formatConfig);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getPartsFormatter", function (currencySettings) {
      return function (amount) {
        return formatCurrencyToParts(amount, currencySettings);
      };
    });
    return _this;
  }
  var _proto = PremiumCurrencyFormatter.prototype;
  _proto.render = function render() {
    var _this2 = this;
    return /*#__PURE__*/React.createElement(PremiumLocaleContext.Consumer, null, function (_ref) {
      var currencyCode = _ref.currencyCode,
        currencySettings = _ref.currencySettings;
      var settings = currencySettings;
      var selectedCurrencySettings = _objectSpread(_objectSpread({}, settings[_this2.props.currencyCode || currencyCode]), _this2.props.currencySettingsOverride);
      return _this2.props.render(_this2.getCurrencyFormatter(selectedCurrencySettings), _this2.getPartsFormatter(selectedCurrencySettings));
    });
  };
  return PremiumCurrencyFormatter;
}(React.Component);
_defineProperty(PremiumCurrencyFormatter, "defaultProps", {
  currencySettingsOverride: {}
});